import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "../partials/Header";
import Footer from "../partials/Footer";
import Utils from "../../../utils";
import "../../../assets/guestportal.css";

function Layout() {
    const [themeClass, setThemeClass] = useState('');
    const location = useLocation();

    const hiddenPaths = [
        "/manage/sleeves-files/summary/:randomId",
        "/manage/my-files/summary/:randomId"
    ];

    // const shouldHideHeaderFooter = hiddenPaths.some((path) => {
    //     const pathRegex = new RegExp("^" + path.replace(/:[^/]+/g, "[^/]+") + "$");
    //     return pathRegex.test(location.pathname);
    // });

    useEffect(() => {
        const interval = setInterval(() => {
            let userData = Utils.loginUserData();
            if (Object.keys(userData).length > 0) {
                if (userData.theme_color) {
                    setThemeClass(userData.theme_color);
                } else {
                    setThemeClass('');
                }
            }
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`wrapper ${themeClass}`}>
            {/* {!shouldHideHeaderFooter && <Header />} */}
            <Header />
            
            <Outlet />

            <Footer />

            {/* {!shouldHideHeaderFooter && <Footer />} */}
        </div>
    );
}

export default Layout;
